import i18n from "@/locales/i18n";
import { ClearAllCacheFromIndexedDB } from "../IndexedDB/CacheIndexedDB";
import store from "../controller/baseController";
import router from "../router";
import shareHelper from "./shareHelper";
import { ClearMasterTabFromCookies } from "./tabHelper";

const SetMetaTagRobots = (to) => {
  shareHelper.RemoveMetaTagName("robots");
  if (to.meta.noindex !== false) {
    shareHelper.CreateMetaTagName("robots", "noindex");
  }
};

const SetMetaTagDescription = (to) => {
  shareHelper.RemoveMetaTagName("description");
  if (to.meta.description) {
    shareHelper.CreateMetaTagName("description", i18n.t(to.meta.description));
  }
};

const SetMetaTagPropertyOgTitle = (to) => {
  shareHelper.RemoveMetaTagProperty("og:title");
  if (to.meta.propertyOgTitle) {
    shareHelper.CreateMetaTagProperty("og:title", i18n.t(to.meta.propertyOgTitle));
  }
};

const SetMetaTagPropertyOgDescription = (to) => {
  shareHelper.RemoveMetaTagProperty("og:description");
  if (to.meta.propertyOgDescription) {
    shareHelper.CreateMetaTagProperty("og:description", i18n.t(to.meta.propertyOgDescription));
  }
};

export default {
  async CheckAssetTokenValidBeforeRouterChange(fromRouterName) {
    if (!fromRouterName) {
      await this.CheckAssetTokenValid();
    }
  },
  async CheckAssetTokenValid() {
    const isAssetTokenValid = await store.dispatch("DoIntrospectAccessToken");
    if (!isAssetTokenValid) {
      await ClearAllCacheFromIndexedDB();
    }
  },
  AuthorizeModels(routerName) {
    if (
      routerName !== "logout" &&
      routerName !== "end" &&
      routerName !== "from_register" &&
      routerName !== "register" &&
      routerName !== "sme_register" &&
      routerName !== "accountingfirm_register" &&
      routerName !== "selectUserType" &&
      routerName !== "forgotPwd" &&
      routerName !== "resetPwd" &&
      routerName !== "sessionExpire" &&
      routerName !== "tooManyRequest" &&
      routerName !== "canNotAccessMerchant" &&
      routerName !== "update" &&
      routerName !== "acceptInvitation" &&
      routerName !== "accepInvitationFailPage" &&
      routerName !== "selectApplication" &&
      routerName !== "registerV2" &&
      routerName !== "entrepreneur_register" &&
      routerName !== "accountant_register" &&
      routerName !== "register_partner" &&
      routerName !== "entrepreneur_register_partner" &&
      routerName !== "accountant_register_partner" &&
      routerName !== "trial_function_salesdocuments" &&
      routerName !== "trial_function_payroll" &&
      routerName !== "trial_function_tax" &&
      routerName !== "trial-function-accounting-payroll" &&
      routerName !== "emailVerification" &&
      routerName !== "download_peak_mobile"
    ) {
      if (routerName == "login") {
        store.dispatch("DoGetRefreshTokenExpiration");
      } else {
        store.dispatch("authorizeModels");
      }
    }
  },
  SetSessionEMIFromURL(emi) {
    let getSession = sessionStorage.getItem("userMerchant");
    getSession = JSON.parse(getSession);
    if (!getSession) {
      getSession = {
        eui: "",
        emi: emi,
      };
    } else {
      getSession.emi = emi ? emi : "";
    }
    sessionStorage.setItem("userMerchant", JSON.stringify(getSession));
  },
  SetLastUrl(to) {
    if (
      to.name !== "logout" &&
      to.name !== "end" &&
      to.name !== "login" &&
      to.name !== "pageNotFound" &&
      to.name !== "createOrganization" &&
      to.name !== "createOrganizationDemo" &&
      to.name !== "from_register" &&
      to.name !== "sme_register" &&
      to.name !== "accountingfirm_register" &&
      to.name !== "selectUserType" &&
      to.name !== "forgotPwd" &&
      to.name !== "resetPwd" &&
      to.name !== "update" &&
      to.name !== "acceptInvitation" &&
      to.name !== "accepInvitationFailPage" &&
      to.name !== "selectApplication" &&
      to.name !== "sessionExpire" &&
      to.name !== "tooManyRequest" &&
      to.name !== "welcome" &&
      to.name !== "canNotAccessMerchant" &&
      to.name !== "register" &&
      to.name !== "entrepreneur_register" &&
      to.name !== "accountant_register" &&
      to.name !== "register_partner" &&
      to.name !== "accountant_register_partner" &&
      to.name !== "entrepreneur_register_partner" &&
      to.name !== "trial_function_salesdocuments" &&
      to.name !== "trial_function_payroll" &&
      to.name !== "trial_function_tax" &&
      to.name !== "trial-function-accounting-payroll" &&
      to.name !== "emailVerification" &&
      to.name !== "download_peak_mobile"
    ) {
      let queryStr = "";
      for (const [key, value] of Object.entries(to.query)) {
        if (value) {
          queryStr += `${key}=${value}&`;
        }
      }
      localStorage.setItem(
        "lastUrlPeakAccount",
        `${window.location.origin}${to.path}${queryStr ? "?" + queryStr : ""}`
      );
    }
  },
  DeleteLastUrl() {
    localStorage.removeItem("lastUrlPeakAccount");
  },
  GetLastUrl() {
    return localStorage.getItem("lastUrlPeakAccount");
  },
  CheckCanNext(next) {
    const isActiveAlertRedirect = store.getters.GetIsActiveAlertRedirect;
    if (!isActiveAlertRedirect) {
      next();
    } else {
      const alertMessage = confirm(i18n.t("Confirm_Leave_Site"));
      if (alertMessage) {
        store.dispatch("DoActiveAlertRedirect", false);
        next();
      }
    }
  },
  SetMetaTagFromRouter(to) {
    SetMetaTagRobots(to);
    SetMetaTagDescription(to);
    SetMetaTagPropertyOgTitle(to);
    SetMetaTagPropertyOgDescription(to);
  },
  HandleLoginLastUrlNavigation() {
    const lastUrl = localStorage.getItem("lastUrlPeakAccount");
    if (lastUrl) {
      ClearMasterTabFromCookies();
      localStorage.removeItem("lastUrlPeakAccount");
      window.location.href = lastUrl;
    } else {
      router.push({ name: "selectlist" });
    }
  },
};
